import React, { useCallback } from 'react';
import { FieldProps } from 'formik';
import styled from 'styled-components';
import { LinkSwitch } from '@sdir/sds';

interface FormLinkSwitchProps extends FieldProps {
  activeLabel: string;
  inactiveLabel: string;
  className?: string;
}

const FormLinkSwitch: React.FC<FormLinkSwitchProps> = ({
  field,
  activeLabel,
  inactiveLabel,
  className = '',
  form,
}) => {
  const handleActiveChange = useCallback(
    (isAcive) => {
      form.setFieldValue(field.name, isAcive);
    },
    [form, field]
  );

  return (
    <Container className={className}>
      <LinkSwitch
        active={!!field.value}
        activeLabel={activeLabel}
        inactiveLabel={inactiveLabel}
        onActiveChange={handleActiveChange}
      />
    </Container>
  );
};

const Container = styled.div`
  div > input,
  input[type='number'] {
    ::-webkit-inner-spin-button,
    ::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    -moz-appearance: textfield;
  }
`;

export default FormLinkSwitch;
